import React from "react";

const motivos = [
  ["abordaje_fuera_terminal", "Abordé el bus fuera de la terminal y no recibí tiquete"],
  ["taquilla_cerrada", "La taquilla estaba cerrada"],
  ["prestador_no_expide", "El prestador no expidió el tiquete"],
  ["sin_punto_venta", "No había taquilla ni punto de venta en el lugar de abordaje"],
  ["pago_a_bordo_sin_comprobante", "Pagué a bordo del bus y no me entregaron comprobante"],
  ["falla_sistema_expedicion", "El prestador informó una falla del sistema para expedir el tiquete"],
  ["falla_impresora", "El prestador informó una falla de impresión o falta de papel"],
  ["tiquete_digital_no_recibido", "No recibí el tiquete digital y no pude obtener una copia"],
  ["tiquete_extraviado", "Extravié el tiquete y no pude obtener un duplicado"],
  ["tiquete_deteriorado", "El tiquete quedó ilegible o deteriorado y no pude obtener un duplicado"],
  ["otro", "Otro motivo"],
];

export function prepararTransportes(trayectos, dias) {
  return trayectos.map(({ archivo, ...trayecto }) => {
    const dia = dias.find(d => d._id === trayecto.agendaDiaObjectId);
    const etiqueta = `${trayecto.sentido === "ida" ? "Ida" : "Regreso"} del ${dia?.fecha?.split("T")[0] || "día no disponible"}`;
    if (!dia) throw new Error("Un transporte pertenece a un día que ya no está en la agenda. Revisa la agenda antes de guardar.");
    if (trayecto.valorPagado === "" || trayecto.valorPagado == null || !Number.isFinite(Number(trayecto.valorPagado)) || Number(trayecto.valorPagado) < 0) {
      throw new Error(`${etiqueta}: indica un valor pagado válido.`);
    }
    if (trayecto.tieneTiquete === true && !archivo && !trayecto.soporteTiquete) {
      throw new Error(`${etiqueta}: adjunta el tiquete.`);
    }
    if (trayecto.tieneTiquete === false && (!trayecto.motivoSinTiquete || !trayecto.explicacionSinTiquete?.trim())) {
      throw new Error(`${etiqueta}: selecciona el motivo y explica por qué no tienes tiquete.`);
    }
    return { ...trayecto, valorPagado: Number(trayecto.valorPagado), medioTransporte: "bus" };
  });
}

export default function TransporteLegalizacion({ dias, trayectos, onChange, habilitado, descargar, error, onError }) {
  function cambiar(dia, sentido, patch) {
    const actual = trayectos.find(t => t.agendaDiaObjectId === dia._id && t.sentido === sentido);
    const otros = trayectos.filter(t => !(t.agendaDiaObjectId === dia._id && t.sentido === sentido));
    onChange([...otros, { agendaDiaObjectId: dia._id, sentido, valorPagado: "", ...actual, ...patch }]);
  }
  const total = trayectos.reduce((s, t) => s + (Number(t.valorPagado) || 0), 0);
  return <section aria-label="Transporte por día">
    <h6 className="fw-semibold">Transporte por día</h6>
    <p className="text-secondary">La fecha y los recorridos vienen de la agenda. Indica por separado si tienes tiquete de ida y de regreso. Registra únicamente los gastos realizados en bus.</p>
    {error && <div className="alert alert-danger" role="alert">{error}</div>}
    {!dias.length && <div className="alert alert-info">La agenda no tiene días registrados.</div>}
    {dias.map((dia, i) => <section key={dia._id} className="border rounded-3 p-3 mb-3">
      <h6>Día {i + 1} · {dia.fecha?.split("T")[0]?.split("-").reverse().join("/")}</h6>
      <div className="row g-3">
        {["ida", "regreso"].map(sentido => {
          const t = trayectos.find(item => item.agendaDiaObjectId === dia._id && item.sentido === sentido);
          const clave = `${dia._id}-${sentido}`;
          return <div className="col-12 col-lg-6" key={sentido}>
            <fieldset className="border rounded-3 p-3 h-100" disabled={!habilitado}>
              <legend className="float-none w-auto fs-6 px-2">{sentido === "ida" ? "Ida" : "Regreso"}</legend>
              <p className="small text-secondary">{(sentido === "ida" ? dia.rutaIda : dia.rutaRegreso) || "Sin ruta registrada"} · Bus</p>
              <label className="form-label" htmlFor={`tiquete-${clave}`}>¿Tiene tiquete?</label>
              <select id={`tiquete-${clave}`} className="form-select mb-3" value={t ? String(t.tieneTiquete) : ""} onChange={e => {
                if (e.target.value === "") {
                  onChange(trayectos.filter(item => !(item.agendaDiaObjectId === dia._id && item.sentido === sentido)));
                } else {
                  cambiar(dia, sentido, { tieneTiquete: e.target.value === "true", soporteTiquete: undefined, archivo: undefined, motivoSinTiquete: undefined, explicacionSinTiquete: undefined });
                }
              }}>
                <option value="">Sin gasto registrado</option>
                <option value="true">Sí, tengo tiquete</option>
                <option value="false">No tengo tiquete</option>
              </select>
              {t && <>
                <label className="form-label" htmlFor={`valor-${clave}`}>Valor pagado (COP)</label>
                <input id={`valor-${clave}`} className="form-control mb-3" type="number" min="0" step="0.01" value={t.valorPagado} onChange={e => cambiar(dia, sentido, { valorPagado: e.target.value })} />
                {t.tieneTiquete ? <>
                  <label className="form-label" htmlFor={`archivo-${clave}`}>{t.soporteTiquete ? "Reemplazar tiquete" : "Adjuntar tiquete"}</label>
                  <input id={`archivo-${clave}`} type="file" className="form-control" accept=".pdf,.jpg,.jpeg,.png,.webp" onChange={e => {
                    const archivo = e.target.files?.[0];
                    if (!archivo) return;
                    if (archivo.size > 8 * 1024 * 1024 || !/\.(pdf|jpe?g|png|webp)$/i.test(archivo.name)) {
                      onError("Selecciona un PDF o una imagen JPG, PNG o WebP de máximo 8 MB.");
                      e.target.value = "";
                      return;
                    }
                    onError(""); cambiar(dia, sentido, { archivo });
                  }} />
                  <div className="small text-secondary mt-1">PDF, JPG, PNG o WebP. Máximo 8 MB. Se carga al guardar.</div>
                  {t.archivo && <div className="small mt-2 text-break">Seleccionado: {t.archivo.name}</div>}
                </> : <>
                  <label className="form-label" htmlFor={`motivo-${clave}`}>Motivo de ausencia del tiquete</label>
                  <select id={`motivo-${clave}`} className="form-select mb-3" value={t.motivoSinTiquete || ""} onChange={e => cambiar(dia, sentido, { motivoSinTiquete: e.target.value })}>
                    <option value="">Selecciona un motivo</option>
                    {motivos.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
                  </select>
                  <label className="form-label" htmlFor={`explicacion-${clave}`}>Explica qué ocurrió</label>
                  <textarea id={`explicacion-${clave}`} className="form-control" rows="3" maxLength="2000" value={t.explicacionSinTiquete || ""} onChange={e => cambiar(dia, sentido, { explicacionSinTiquete: e.target.value })} />
                  <p className="small text-secondary mt-2 mb-0">Esta información servirá para el formato de transporte informal y la declaración juramentada. Su generación aún está pendiente.</p>
                </>}
              </>}
            </fieldset>
            {t?.tieneTiquete && t.soporteTiquete && <button type="button" className="btn btn-link px-0" onClick={() => descargar(t.soporteTiquete)}>Descargar tiquete guardado de {sentido}</button>}
          </div>;
        })}
      </div>
    </section>)}
    <p className="fw-semibold text-end">Total registrado: {total.toLocaleString("es-CO", { style: "currency", currency: "COP" })}</p>
  </section>;
}
